import {
  GetHeatingCoolingLoadInputsType,
  SizingCalculatorResultType
} from 'data/types';
import { emptyApi } from './empty-api';

const sizingCalculatorApi = emptyApi.injectEndpoints({
  endpoints: (builder) => ({
    getStructureHeatingCoolingLoad: builder.query<
      SizingCalculatorResultType,
      GetHeatingCoolingLoadInputsType | null
    >({
      query: (body) => ({
        url: 'sizing/get-heating-cooling-load',
        method: 'POST',
        body
      }),
      providesTags: ['SizingLoad']
    })
  })
});

export const { useGetStructureHeatingCoolingLoadQuery } = sizingCalculatorApi;
